import { IChildrenProp, IDiv } from 'types/components/components.interface';
import './MagellanPopup.scss';
import { MagellanPopupHeader } from './modules';
import MagellanPopupBottomButtons from './modules/bottom-buttons/MagellanPopupBottomButtons';

interface IMagellanPopupProps extends IChildrenProp, IDiv {}

const MagellanPopup = ({
  children,
  className = '',
  ...props
}: IMagellanPopupProps) => {
  return (
    <div {...props} className={`magellan-popup ${className}`}>
      {children}
    </div>
  );
};

MagellanPopup.Header = MagellanPopupHeader;
MagellanPopup.BottomButtons = MagellanPopupBottomButtons;

export default MagellanPopup;
